import { sanitizeReturnPath } from './ssoParams.js';

export const DEFAULT_AUTH_RETURN_PATH = '/courses';

export function getPostAuthDestination(returnPath, onboardingPending) {
  const url = new URL(sanitizeReturnPath(returnPath), 'https://step.local');
  // The public Play Console URL hands authenticated visitors to the in-app page.
  if (url.pathname.replace(/\/$/, '') === '/delete') url.pathname = '/account/delete';
  if (onboardingPending && url.pathname !== '/account/delete') return '/onboarding';
  return `${url.pathname}${url.search}${url.hash}`;
}

export function locationToReturnPath(location) {
  if (!location) return DEFAULT_AUTH_RETURN_PATH;
  return sanitizeReturnPath(
    `${location.pathname || ''}${location.search || ''}${location.hash || ''}`,
  );
}

function normalizeStateReturnPath(from) {
  if (!from) return '';
  if (typeof from === 'string') return from;
  return `${from.pathname || ''}${from.search || ''}${from.hash || ''}`;
}

export function getAuthReturnPath(location, searchParams) {
  const queryReturnPath = searchParams?.get?.('return_path') || '';
  const stateReturnPath = normalizeStateReturnPath(location?.state?.from);
  return sanitizeReturnPath(queryReturnPath || stateReturnPath || DEFAULT_AUTH_RETURN_PATH);
}

// default return path is /courses, but if the user was redirected to /signin from a payment flow, we want to return them to the payment flow after signing in.
export function getPaymentLoginContext(searchParams, returnPath) {
  // RequireAuth preserves links arriving at / inside return_path.
  // Also accept payment details supplied directly to /signin.
  const params = searchParams.has('referrer')
    ? searchParams
    : new URL(sanitizeReturnPath(returnPath), 'https://step.local').searchParams;

  if (params.get('referrer') !== 'newpayment') return null;

  return {
    loginId: (params.get('loginId') || '').trim(),
    productName: (params.get('pname') || '').trim(),
  };
}

export function buildSignInRedirect(location) {
  const returnPath = locationToReturnPath(location);
  const search = new URLSearchParams({ return_path: returnPath }).toString();
  return {
    pathname: '/signin',
    search: `?${search}`,
  };
}
